import React, { Suspense, useEffect, useState } from "react";
import ViewerComponent from "./modules/3dViewer/ViewerComponent";
import { ViewerProvider } from "./context/ViewerContext";

import MapLoader from "./modules/loader/MapLoader";
import TimeLineComponent from "./modules/timeline/TimeLineComponent";
import FetchSatelliteData from "./modules/fetchSatelliteData/FetchSatelliteData";
import InfoComponent from "./modules/InfoComponent/InfoComponent";
import CreateSatelliteDataSource from "./modules/createDataSource/CreateSatelliteDataSource";
import CreateLinkDataSource from "./modules/createDataSource/CreateLinkDataSource";
import CreateStationDataSource from "./modules/createDataSource/CreateStationDataSource";
import ConfigTool from "./modules/configuration/ConfigTools";

function CesiumViewer({ callback }) {
  const [loaded, setLoaded] = useState(true);
  return (
    <>
      {loaded && (
        <ViewerProvider>
          <ViewerComponent callback={callback}>
            <MapLoader status={false} />
            <FetchSatelliteData />
            <CreateSatelliteDataSource/>
            <CreateLinkDataSource/>
            <CreateStationDataSource/>
            <InfoComponent/>
            <TimeLineComponent/>
            <ConfigTool/>
          </ViewerComponent>
        </ViewerProvider>
      )}
    </>
  );
}

export default CesiumViewer;
